export default __webpack_public_path__ + "static/media/icon-manage-categories.7e05ef3f.svg";